





































































import DamageLocatorCombined from "@/components/damagelocator/DamageLocatorCombined.vue";
import PartnerReportDetailImageTimeLineElement from "@/components/partner/PartnerReportDetailImageTimeLineElement.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDate } from "@/lib/utility/date-helper";
import { downloadUrlFromRemoteOrigin } from "@/lib/utility/downloadFileFunc";
import { $t } from "@/lib/utility/t";
import { IReport } from "@/models/report.entity";
import { MrfiktivDocumentViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    PartnerReportDetailImageTimeLineElement,
    DamageLocatorCombined
  }
})
export default class MyDamageDetail extends Vue {
  @Prop({ required: true })
  report!: IReport;

  renderComponent = true;

  get reportType() {
    return this.report?.reportType;
  }

  get damageLocation() {
    this.forceRerender();
    return this.report?.damage ?? [];
  }

  get hasDamageLocation(): boolean {
    return this.damageLocation?.length > 0 || false;
  }

  get images() {
    return this.report?.images;
  }

  get hasImages() {
    if (!this.report) {
      return false;
    }

    return this.report.attachment.length > 0;
  }

  get color() {
    return ReportModule.partner.settings?.color ?? "#6fb38a";
  }

  get hasDocuments() {
    return this.report?.documents && this.report.documents.length > 0;
  }

  get documentCount() {
    return this.report?.documents?.length || 0;
  }

  get items() {
    const items: { text: string; value?: string }[] = [
      {
        text: $t("common.nouns.company"),
        value: this.report?.companyName
      },
      {
        text: $t("objects.vehicle.costCenter"),
        value: this.report?.costCenter || ""
      },
      {
        text: $t("report.user.MyDamageDetail.numberplate"),
        value: this.report?.numberplate || ""
      },
      {
        text: $t("common.nouns.fleet"),
        value: this.report?.fleet?.title || ""
      }
    ];

    items.push({
      text: $t("objects.report.leasing.claimNumber"),
      value: this.report?.claimNumber
    });

    items.push(
      {
        text: $t("objects.report.status"),
        value: this.report?.status ? this.report?.status : $t(`enums.ProgressStatusEnum.${this.report?.progressStatus}`)
      },
      {
        text: $t("report.accidentDetails.date"),
        value: this.report?.accidentDetails?.date ? simpleDate(this.report?.accidentDetails?.date) : ""
      },
      {
        text: $t("objects.report.coverageType"),
        value: $t(`enums.CoverageTypeEnum.${this.report?.coverageType}`)
      },
      {
        text: $t("objects.report.tripType"),
        value: $t(`enums.TripTypeEnum.${this.report?.tripType}`)
      },
      {
        text: $t("objects.report.damageType"),
        value: $t(`enums.DamageTypeEnum.${this.report?.damageType}`)
      },
      {
        text: $t("report.user.MyDamageDetail.customerName"),
        value: this.report?.customerName || ""
      },

      {
        text: $t("report.user.MyDamageDetail.message"),
        value: this.report?.message || ""
      },
      {
        text: $t("report.user.MyDamageDetail.accidentDetailsAdress"),
        value: this.report?.accidentDetails?.address.toString() || ""
      },
      {
        text: $t("report.user.MyDamageDetail.location"),
        value: this.report?.location?.toString() || ""
      },
      {
        text: $t("components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.parties.workshop"),
        value: this.report.workShopCompany?.company
      },
      {
        text: $t("objects.report.repair.status"),
        value: $t(`enums.RepairStatusEnum.${this.report?.repair?.status}`)
      },
      {
        text: $t("objects.report.repair.startDate"),
        value: this.report?.repair?.startDate ? simpleDate(this.report?.repair?.startDate) : ""
      },
      {
        text: $t("objects.report.repair.endDate"),
        value: this.report?.repair?.endDate ? simpleDate(this.report?.repair?.endDate) : ""
      },
      {
        text: $t("objects.report.invoiceInboundAggregation"),
        value: this.report?.invoiceInboundAggregation?.totals
          ?.map(t => formatCurrency(t.subtotal, t.currency as CurrencyEnum))
          .join(", ")
      },
      {
        text: $t("objects.report.invoiceSelfContributionAggregation"),
        value: this.report?.invoiceSelfContributionAggregation?.totals
          ?.map(t => formatCurrency(t.subtotal, t.currency as CurrencyEnum))
          .join(", ")
      }
    );

    if (this.report?.leasing?.claimNumber) {
      items.push({
        text: `${$t("objects.report.leasing.claimNumber")} (${$t(
          "components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.leasingDetails.title.leasing"
        )})`,
        value: this.report.leasing.claimNumber
      });
    }

    for (const insurance of this.report?.insurances ?? []) {
      if (!insurance.isActive) continue;

      items.push({
        text: `${insurance.name} (${$t(`enums.CoverageTypeEnum.${insurance.type}`)})`,
        value: insurance.number
      });
    }

    if (this.report.policeDetails?.isRecorded) {
      items.push({
        text: $t("report.policeDetails.title"),
        value: $t("report.policeDetails.isPolicy")
      });
    } else {
      items.push({
        text: $t("report.policeDetails.title"),
        value: $t("report.policeDetails.isNotPolicy")
      });
    }

    return items;
  }

  get getDamageLocatorWidth() {
    return "250px";
  }

  get getDamageLocatorHeight() {
    return "300px";
  }

  formatFileSize(bytes: number | undefined) {
    if (!bytes) return "0 MB";
    const mb = bytes / (1024 * 1024);
    if (mb < 0.1) {
      const kb = bytes / 1024;
      return kb < 1 ? "< 1 KB" : `${Math.round(kb)} KB`;
    }
    return `${mb.toFixed(1)} MB`;
  }

  async downloadDocument(document: MrfiktivDocumentViewModelGen) {
    const fileName = document.title || document.name;

    await downloadUrlFromRemoteOrigin(document.url, fileName);
  }

  openInNewTab(document: MrfiktivDocumentViewModelGen) {
    if (document.url) {
      window.open(document.url, "_blank");
    }
  }

  async downloadAllDocuments() {
    if (!this.report?.documents || this.report.documents.length === 0) {
      return;
    }

    this.report?.documents?.forEach(this.downloadDocument);
  }

  forceRerender() {
    // remove the my-component component from the DOM
    this.renderComponent = false;

    this.$nextTick(() => {
      // add my-component component in DOM
      this.renderComponent = true;
    });
  }
}
